import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "react-query";

import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { postUserAuth } from "../common/api";

import logo from '../assets/img/klett-baza-wiedzy-logo-lg.png';


const LoginComponent = () => {

  const navigate = useNavigate();
  const [loginSuccess, setLoginSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const postUserAuthQuery = useQuery(
    ['userData', {}], // Unikalny identyfikator zapytania
    () => postUserAuth(username, password), // Funkcja wykonująca zapytanie
    {
      enabled: false, // Wyłącz zapytanie na starcie
      retry: false,
      refetchOnWindowFocus: false
    }
  );


  useEffect(() => {
    if(postUserAuthQuery.isError){
        return <div>Wystapił bład podczas ładowania treści</div>
    }
    if(postUserAuthQuery.isFetched === true && postUserAuthQuery.isSuccess === true && loading === true){
    
      if(postUserAuthQuery.data !== undefined && postUserAuthQuery.data.data !== undefined && postUserAuthQuery.data.data.data !== undefined && Object.keys(postUserAuthQuery.data.data.data).length > 0){
        let responseData = postUserAuthQuery.data.data.data;
        if(responseData.status === "success" && responseData.token.length > 0 && Object.keys(responseData.data).length > 0){

          localStorage.clear();
          localStorage.setItem("jwt", responseData.token);
          localStorage.setItem("permissions", JSON.stringify(responseData.data.permissions));
          localStorage.setItem("uid", responseData.data.uid);
          localStorage.setItem("profile", JSON.stringify(responseData.data.profile));
          localStorage.setItem("expires", responseData.data.expires);
          
          setLoginSuccess(true);
          setLoading(false);
          setUsername("");
          setPassword("");

          const url = new URL(window.location.href);
          let redirect = url.searchParams.get('redirect');

          const query = url.searchParams.get('query');
          if(query !== null){
            redirect = redirect + "&query=" + query; 
          }
          if(redirect === null){
            redirect = "/"
          }

          window.location.href = redirect;  
        }
      }
  
    }
    

  }, [postUserAuthQuery])

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    await postUserAuthQuery.refetch(); // Wykonaj zapytanie po kliknięciu przycisku "Zaloguj się"
  
  }

  

  return(
    <React.Fragment>
      <Container className="loginForm">

      <Row className="pt-5">
        <Col sm={12} md={6} lg={6}>

          <Row>
            <Col className="col-lg-8 col-10 offset-lg-2 offset-1">
              <div id="loginForm" className="border border-0 put-shadow card">
                <div className="cart-body">

                  <Row className="mb-4">
                    <Card.Title className="text-center h2 mb-4 text-uppercase">LOGOWANIE</Card.Title>
                    <Card.Title className="text-center">Nie masz konta?<br/><a href="https://klett.pl/rejestracja" target="_blank" title="Zarejestruj się" >Utwórz konto</a></Card.Title>
                  </Row>

                  <Form className="border border-end-0 border-start-0 py-4 my-4" onSubmit={handleSubmit}>
                    <Form.Group className="mb-4">
                      <Form.Label className="w-100 form-label">Email</Form.Label>
                      <Form.Control type="email" placeholder="Podaj adres e-mail" name="username" value={username} disabled={loading === true ? "disabled" : null} onChange={(e) => setUsername(e.target.value)} required />
                    </Form.Group>

                    <Form.Group className="mb-4">
                      <Form.Label className="w-100 form-label">Hasło</Form.Label>
                      <Form.Control type="password" placeholder="Podaj hasło" name="password" value={password} disabled={loading === true ? "disabled" : null} onChange={(e) => setPassword(e.target.value)} required />
                    </Form.Group>

                    <Button className="btn-primary w-100 mt-2" disabled={loading === true ? "disabled" : null} type="submit">{loading === true ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : "Zaloguj się"}</Button>
                  </Form>

                  <div className="text-center">
                    <a href="" target="_blank">Nie pamiętasz hasła?</a>
                  </div>

              </div>
            </div>
            </Col>
          </Row>

        
        </Col>
        <Col sm={12} md={6} lg={6} className="text-center">
          <img src={logo} alt="Baza wiedzy Klett Polska" className="img-fluid"/>
        
          <Row className="mt-4">
            <Col lg={{span: 10, offset: 1}}>
              <p className="mb-4 welcomeInfo">
              Baza wiedzy to stale rozwijany przez nas zbiór wartościowych materiałów dydaktycznych. To nie tylko pełna dokumentacja nauczyciela, ale również setki gotowych do wykorzystania na zajęciach scenariuszy, kart pracy, sprawdzianów, kartkówek, prezentacji, grafik, dyplomów i wiele innych ciekawych pomocy edukacyjnych.
              </p>
            </Col>
          </Row>
        </Col>
      </Row>


      
      </Container>

      

    </React.Fragment>
  )

}
export default LoginComponent;